import { Button } from '@mui/material';
import { Icons } from '../../components/Icons';
import megagoLogo from '../../assets/icons/megaGo.svg';
import rokuLogo from '../../assets/img/roku-logo.png';

export default function OnboardingRokuContainer({ navigate, keycloak, randomVideo }) {
  return (
    <div className='onboardingContainer onboardingRoku'>
      <div className='videoBg videoBgNoBorder'>
        <iframe
          src={`https://mdstrm.com/embed/${randomVideo}?controls=false&volume=0&autoplay=true&loop=true`}
          width='640'
          height='360'
          allow='autoplay; fullscreen; encrypted-media'
          frameBorder='0'
          allowscriptaccess='always'
          scrolling='no'
          title='video background'>
        </iframe>
      </div>
      <div className='sectionListWrap'>
        <div className='sectionBg'></div>
        <section className='fullHSection heroSection'>
          <header>
            <div className='logos'>
              <Icons path={megagoLogo} className='heroLogo' />
              <img src={rokuLogo} alt='RokuLogo' />
            </div>
            <p>Disfruta de tus teleseries favoritas, de tus programas preferidos<br /> y de eventos exclusivos cuando y donde quieras.</p>
            <div className='obIntroButtonsWrap'>
              <Button
                className='introButton'
                variant='outlined'
                onClick={() => keycloak.register()}
              >
                Crear una cuenta
              </Button>
              <span className='difLine'>o</span>
              <Button
                className='introButton'
                variant='outlined'
                onClick={() => navigate('/roku/planes')}
              >
                Contratar un plan
              </Button>
            </div>
          </header>
        </section>
      </div>
    </div>
  )
}